import { DefaultTheme } from 'styled-components';

import { gardenaLightTheme, lightTheme } from 'styles/themes';
import { gardenaSlideshowImages, slideshowImages } from 'assets/images';

export type BrandConfig = {
  theme: DefaultTheme;
  slideshowImages: string[];
  slideshowDuration: number;
};

const defaultConfig: BrandConfig = {
  theme: lightTheme,
  slideshowImages: slideshowImages,
  slideshowDuration: 4
};

const gardenaConfig: BrandConfig = {
  theme: gardenaLightTheme,
  slideshowImages: gardenaSlideshowImages,
  slideshowDuration: 8
};

export const brandConfigs: Record<string, BrandConfig> = {
  gardena: gardenaConfig,
  default: defaultConfig
};
